<script>
    import BlogSummary from '../components/BlogSummary.svelte';
    export let short = false;
    export let blogUrl = "onko-sellaista-kun-liian-huono-kunto";
    let title = "Liian huono kunto?";
    let author = "Petteri";
    let blogDate = "3.4.2019";
    let titlePic = "kahvakuulat-4-1500x630.jpg";
    let firstPara = "Kun olen kutsunut kiinnostuneita treenaajia piipahtamaan salille tutustumaan, olen usein törmännyt kommenttiin " +
        "\"täytyy ensin hieman treenata, ennen kuin uskaltaa tulla käymään\".";
</script>
<!--  Blogi koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
<BlogSummary blogPath={blogUrl} title={title} titlePic={titlePic} blogDate={blogDate} firstPara={firstPara}></BlogSummary>

{:else}
    <div class="blog page">
        <article class="container">
            <h1>{title}</h1>
            <div class="blogDate">{author} | {blogDate}</div>
            <div class="blogMainImage" style="background-image: url('/svelte-site/img/blog/{titlePic}')"></div>
            <p>{firstPara}</p>

            <p>
                Voin luvata, että tämä on täysin turha huolenaihe, sillä meitä “huonokuntoisia” on joka puolella. Aina
                löytyy joku joka voi tehdä saman asian nopeammin tai paremmin.
            </p>
            <p>
                Kunnon taso on suhteellista. Tai mitä kunnolla edes tarkoitetaan? Moni itseään "hyväkuntoisena" pitävä
                voi yllättyä, kun uudenlainen treeni saa koneen hyytymään. Kunto on ominaisuus, joka ei näy päällepäin
                eikä siinä kannata verrata itseään muihin.
            </p>
            <p>
                <strong>Dynamosalille voit tulla tutustumaan</strong> koska tahansa päivystysaikoina, 
                tekemällä oman treenin tai osallistumalla ryhmätunnille. Ryhmätreenit 
                haastavat aloittelijan, mutta niin ne haastavat kokeneenkin. Treenit voidaan skaalata helpommaksi tai
                haastavammaksi, ja kokenut treenaaja osaa ottaa itsestään ennemmän irti. Tule rohkeasti mukaan kokeilemaan. 
                Parhaassa tapauksessa voit ylittää itsesi ja löytää itsestäsi ihan uusia taitoja sekä löytää itsellesi
                uuden, pitkäaikaisen ja innostavan harrastuksen.
                
            </p>
            <p>
                --<br>
                Petteri
            </p>

        </article>
        <section class="container">
            <h2>Lue seuraavaksi</h2>
            <div class="row">
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='vinkit_kestavaan_muutokseen' title='12 vinkkiä pysyvään muutokseen' titlePic='2023/healthy.jpg' firstPara='Haikailetko viimeistään kevätlumien sulaessa kadonnutta alkuvuoden intoa ja treenimotivaatiota? Lue tästä Dynamosalin vinkit kestävään muutokseen.' blogDate=''></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='miten-tehda-treenaamisesta-hauskaa' title='Miten tehdä treenaamisesta hauskaa?' titlePic='dynamopaidat.jpg' blogDate='' firstPara='Salilla on kiva käydä ja siitä tulee keskimäärin mukavampaa, jos siellä kehittyy. Eikö vain?'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='stressitomasti-tuloksiin' title='Stressittömästi tuloksiin' titlePic='riippumatto.jpg' blogDate='' firstPara='Meillä kaikilla on jokin syy motivaattorina, minkä vuoksi treenaamme - jos ja kun treenaamme. Jos haluat näkyviä tuloksia, tai vaikka treenaisit vain omaksi iloksesi tai puolisosi käskystä, kannattaa tämä lukea.'></BlogSummary>
                </article>
            </div>
        </section>

    </div>
{/if}

<style>


</style>